<template>
    <div class="wid-100">
        <!-- 收藏专家 -->
        <collect></collect>
    </div>
</template>

<script>
    import collect from '@/components/collect.vue';
    export default {
        components: {
            collect,
        },
        data() {
            return {

            }
        },
        created() {

        },
        mounted() {},
        methods: {}
    }
</script>

<style scoped>
</style>
